import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, Dropdown, List, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TransformUnix } from '../../_config/functions/transform-unix';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import { getTimeAgo } from '../../_config/utils/get-time-ago.handle';
import { ENVIROMENT } from '../../v2-config/constants/enviroments.constant';
import useNotificationStore from '../../v2-pages/notification/store/useNotificationStore';
import { notificationType } from './constants/notification-type.constant';
import { checkNotificationType } from './handle/check-notification-type.handle';
import { status } from './constants/status.constant';
import { typeDelivery } from './constants/type-delivery';
import { Service } from './service';

import './style.scss';

const NotificationBell = () => {
	const [notifications, setNotifications] = useState([]);
	const [pharmacy, setPharmacy] = useState(null);
	const notificationCount = useNotificationStore((state) => state.notificationCount);
	const notification = useNotificationStore((state) => state.notifications);
	const markAsSeen = useNotificationStore((state) => state.markAsSeen);

	const page = 1;
	const user = GetLocalStorageValue('userInfo');
	const token = user?.token;

	const { Text } = Typography;

	console.log('NotificationBell - RENDER',notifications);

	useEffect(() => {
		if (user?.pharmacy) {
			setPharmacy(user.pharmacy);
		}
		new Service()
			.getNotificationsByCountry({ page, token, pharmacy })
			.then((response) => {
				console.log('responseNew', response);
				setNotifications(response.data);
			})
			.catch((error) => {
				console.error('Error al recibir las notificaciones:', error);
			});
	}, [page, pharmacy, user?.pharmacy, token, notificationCount]);

	useEffect(() => {
		console.log('useEffect - update dataSource from notifications');

		if (notification.length > 0) {
			setNotifications((prevNotifications) => {
				const existingIds = new Map(prevNotifications.map((item) => [item._id, true]));
				const newNotifications = notification.filter((item) => !existingIds.has(item._id));
				if (newNotifications.length === 0) {
					return prevNotifications;
				}
				return [...newNotifications, ...prevNotifications];
			});
		}
	}, [notification]);

	return (
		<Dropdown
			trigger={['click']}
			placement="bottomRight"
			dropdownRender={() => (
				<div
					style={{
						backgroundColor: '#fff',
						boxShadow: '0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)',
						borderRadius: 8,
						width: 350,
					}}
				>
					<div style={{ padding: '8px 16px', borderBottom: '1px solid #f0f0f0' }}>
						<Text strong>Notificaciones</Text>
					</div>

					<List
						dataSource={notifications}
						style={{
							maxHeight: notifications?.length > 5 ? 400 : 'auto',
							overflowY: notifications?.length > 5 ? 'auto' : 'visible',
						}}
						renderItem={(item) => (
							<Link
								to={
									item?.type === 'new-recipe'
										? checkNotificationType({ notificationType: item.type, isAdmin: user?.admin, pharmacy: item?.data?.pharmacy, type_id: item?.type_id })
										: `/v2/notifications/list?page=1&seen=${item?.seen}`
								}
								onClick={() => item?.type === 'new-recipe' && !item?.seen && markAsSeen(item._id)}
								// to={checkNotificationType({
								// 	notificationType: item?.type,
								// 	isAdmin: user?.admin,
								// 	pharmacy: item?.data?.pharmacy,
								// 	type_id: item?.type_id,
								// })}
								style={{ color: 'inherit', textDecoration: 'none' }}
							>
								<List.Item
									key={item?._id}
									className={`notification-card ${!item?.seen ? 'not-seen-notification-card' : 'seen-notification-card'}`}
									style={{
										padding: '12px 16px',
										borderBottom: '1px solid #f0f0f0',
										cursor: 'pointer',
										':hover': { backgroundColor: '#fafafa' },
									}}
								>
									<List.Item.Meta
										title={
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													width: '100%',
													alignItems: 'flex-end', // Alinea elementos al fondo
												}}
											>
												<div style={{ flex: 1 }}>
													<Text strong>
														{notificationType[item?.type]}
														{item?.type === 'new-quotation' || item?.type === 'new-preorder' ? item?.data?.shortCode : item?.type_id }
													</Text>
													<div style={{ marginTop: 4 }}>
														<Text type="secondary" style={{ fontSize: 12 }}>
															Farmacia: {item?.data?.pharmacy ==='fanich' ? 'La Botica Anich' : item?.data?.pharmacy} 	<br />

														</Text>
														<Text type="secondary" style={{ fontSize: 12 }}>
															Usuario: {item?.email} <br />
														</Text>
														{item?.type === 'new-claim' && (
															<Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
																Estado: {status[item?.data?.status]}
															</Text>
														)}
														{item?.type === 'new-order' && (
															<Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
																{typeDelivery[item?.data?.type_retirement]}
															</Text>
														)}
														<Text type="secondary" style={{ fontSize: 12 }}>
															{TransformUnix[ENVIROMENT.COUNTRY].handleFormat(item?.created_at)}
														</Text>
													</div>
												</div>
												<Text
													type="secondary"
													style={{
														fontSize: 12,
														marginLeft: 8,
														alignSelf: 'flex-end', // Alinea verticalmente al fondo
													}}
												>
													{getTimeAgo(item?.created_at)}
												</Text>
											</div>
										}
									/>
								</List.Item>
							</Link>
						)}
					/>

					<div
						style={{
							textAlign: 'center',
							padding: '8px 0',
							borderTop: '1px solid #f0f0f0',
							visibility: notifications?.length > 0 ? 'visible' : 'hidden',
						}}
					>
						<Link to="/v2/notifications/list?page=1">
							<Button type="link">VER MAS</Button>
						</Link>
					</div>
				</div>
			)}
		>
			<Badge count={notificationCount} size="small">
				<Button
					type="text"
					icon={<BellOutlined style={{ fontSize: '18px' }} />}
					style={{ color: 'rgba(0, 0, 0, 0.65)' }}
					aria-label="Notificaciones"
				/>
			</Badge>
		</Dropdown>
	);
};

export default NotificationBell;
